import { render, staticRenderFns } from "./add.vue?vue&type=template&id=99789ffa&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=99789ffa&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99789ffa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99789ffa')) {
      api.createRecord('99789ffa', component.options)
    } else {
      api.reload('99789ffa', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=99789ffa&scoped=true", function () {
      api.rerender('99789ffa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataAccess/deviceAccess/add.vue"
export default component.exports